import { render, staticRenderFns } from "./FaqQuestions.vue?vue&type=template&id=328782a4&"
import script from "./FaqQuestions.vue?vue&type=script&lang=js&"
export * from "./FaqQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports